module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('i', [_vm._v("Chapter 2")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _vm._v("UNHEALTHY DEPENDENCY ")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace"
  }, [_c('b', [_c('i', [_vm._v("If we examine every disturbance we have, great or small, we will find at the root of it some unhealthy dependency and its consequent unhealthy demand.")])]), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_c('b', [_vm._v("—BILL W.")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("ndependence and self-responsibility are thought to be indispensable to psychological well-being, essential to personal fulfillment, basic to moral life, and the foundations of social cooperation. One writer contends that the essence of independence is the practice of thinking for yourself and reflecting critically on the values and beliefs offered by others— in other words, living by your own critical thinking and judgments."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v("Self-responsibility is the practice of providing for your own needs rather than depending on another individual or entity to provide for them."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v("Ultimately, the kind of person you end up being and the inner strength you will possess depend on those matters for which you are prepared to take responsibility."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v("If you want to be successful, you must take responsibility for achieving success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When you put yourself in a position of dependency, you can harm yourself psychologically in ways most people do not understand. Many forms of dependency can cause untold harm to individuals, their families, and their communities. In seeking to understand such forms of unhealthy dependency, it is useful to first examine some definitions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dependency is defined as a “state of relying on or being controlled by someone or something else.”"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v("Dependence is described as a “lack of independence or self-sufficiency.”"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v("Combining these two notions results in the implication that "), _c('i', [_vm._v("the more dependent you are, the less self-sufficient you are and the less control you exercise over your life")]), _vm._v(" (see figure 2.1). Because of these dangers, it is important to recognize the signs of unhealthy dependency and to offset this development with healthy forms of dependency.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace"
  }, [_c('b', [_c('i', [_vm._v("INVERSE RELATIONSHIP BETWEEN"), _c('br'), _vm._v("DEPENDENCY AND SELF-SUFFICIENCY/CONTROL OVER LIFE")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img44.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('b', [_c('i', [_vm._v("Figure 2.1")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec1-002"
    }
  }), _vm._v("EMOTIONAL DEPENDENCY ")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('i', [_vm._v("If you don’t run your own life, someone else will.")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—JOHN ATKINSON")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabovewithindent"
  }, [_vm._v("As mentioned in "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("chapter 1")]), _vm._v(", one kind of dependency is emotional. In relation to emotional dependency, Fritz Perls, originator of Gestalt Therapy, noted: “Our dependency makes slaves out of us, especially if this dependency is a dependency of our self-esteem. If you need encouragement, pats on the back from everybody, then you make everybody your judge.”"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to psychotherapist Nathaniel Branden, people who depend for their ultimate authority on the opinions or views of others, as opposed to objective reality, share the following key traits:")]), _vm._v(" "), _c('ul', {
    staticClass: "icona"
  }, [_c('li', [_vm._v("They lack a firm, unyielding concept of existence, facts, and reality apart from the judgments, beliefs, opinions, and feelings of others.")]), _vm._v(" "), _c('li', [_vm._v("They experience a fundamental sense of helplessness and powerlessness, a profound fear of other people, and an implicit belief that other people control reality.")]), _vm._v(" "), _c('li', [_vm._v("Their self-esteem hinges on responses of significant others."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An article about emotional dependency explains further that a balance must be found between debilitating and healthy dependency:")]), _vm._v(" "), _c('p', {
    staticClass: "quote1"
  }, [_vm._v("At one extreme is an ingrained, helpless need to be cared for—a stubborn problem that psychiatrists diagnose as dependent personality disorder. In milder forms, dependency can come across as an annoying clinginess. But it can also be a protective warmth that cements romantic relationships in times of stress. It is the way people manage dependent urges, researchers are finding, that determines the effect of needy behavior on relationships. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("A tug-of-war between headstrong independence and needy vulnerability is visible as early as infancy. In so-called attachment studies, young children or primates who are confident in their mother’s affections tend to be confident when exploring an unfamiliar room or meeting a stranger. Those who are less secure often cling to their mothers in new situations, noticeably fearful.")]), _vm._v(" "), _c('p', {
    staticClass: "quote3x"
  }, [_vm._v("“This is an absolutely fundamental dynamic that underlies all of our interpersonal relations, as well as psychiatric diagnoses,” said Dr. Sydney Blatt, a professor of psychology and psychiatry at Yale University."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Angelyn Miller, M.A., author of "), _c('i', [_vm._v("The Enabler")]), _vm._v(", notes:")]), _vm._v(" "), _c('p', {
    staticClass: "quote1"
  }, [_vm._v("It is the differences in the way individuals respond to hard times that separate those who are simply sharing in an interdependent society from those who are dependent.")]), _vm._v(" "), _c('p', {
    staticClass: "quote3"
  }, [_vm._v("People who use their disability, grief or adversity as an excuse to avoid doing what they can are emotionally dependent, and emotional dependence can be even more deadly than economic dependence.")]), _vm._v(" "), _c('p', {
    staticClass: "quote3x"
  }, [_vm._v("Emotional dependents will grasp past or present, real or imagined disappointments as a justification for inaction or pseudoaction. They lay claim to some unwinnable battle and then assert that they could go out into the world and slay dragons if it weren’t for everything that is conspiring against them. As in shadow boxing, their jabs can’t connect with anything real or solid. Some people’s entire lives revolve around overwhelming and irresolvable problems. They are always involved in some crisis that they can’t or are unwilling to resolve. When these people with “irresolvable problems” turn them over to others to handle, and there are willing takers, the cycle of enabling-dependence begins."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec1-003"
    }
  }), _vm._v("ADDICTIONS ")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('i', [_vm._v("Drugs have taught an entire generation of American kids the metric system.")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—P.J.O’ROURKE")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabovewithindent"
  }, [_vm._v("At times, a psychological dependency also involves a powerful physical component, as in addictions, especially those involving drugs, alcohol, or cigarettes. In these cases, the physical dependency results in withdrawal symptoms, a physiological reaction to the sudden absence of the addictive substance, whereas the psychological dependency manifests as the memory of the pleasure or “craving” associated with the addictive substance."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v("For example, a smoker can be physically dependent on nicotine and psychologically dependent on the social aspect of smoking in a group."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "enr12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#ch02en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v("Because such addictions cause harmful emotional dependency, treatment should entail not only physical therapies but also psychological ones.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "sec1-004"
    }
  }), _vm._v("Key Points")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("How can you influence the kind of person you will become?"), _c('br'), _c('i', [_vm._v("The inner strength you possess in the future will reflect the matters for which you have taken responsibility.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_vm._v("Why should unhealthy dependency be avoided?"), _c('br'), _c('i', [_vm._v("Because the more dependent you are, the less control you exercise over your life and the less ability you have to be self-sufficient.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_vm._v("How can increased dependency best be avoided?"), _c('br'), _c('i', [_vm._v("By finding a balance between debilitating and healthy dependency.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_vm._v("What forms can unhealthy dependency take?"), _c('br'), _c('i', [_vm._v("Emotional, psychological, and economic.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_vm._v("Give two examples of unhealthy dependency."), _c('br'), _c('i', [_vm._v("Excessive emotional dependency and addictions involving substance abuse.")]), _c('br'), _c('br')]), _vm._v(" "), _c('li', [_vm._v("What is the difference between emotional dependency and an addiction?"), _c('br'), _c('i', [_vm._v("An addiction is a physical reliance on something, whereas dependency is psychological.")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img047.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "illustration"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/iconb.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 108
// module chunks = 0